import axios from 'axios';

import { ResponseObj } from '../../../back/src/types';
import { TextoEditavel } from '../../../back/src/entity/TextoEditavel';

const textoEditavel = async (id: number): Promise<ResponseObj<TextoEditavel>> => {
  const res = await axios.get<ResponseObj<TextoEditavel>>(`textos_editaveis/${id}`);
  return res.data;
};

const textosEditaveis = async (): Promise<ResponseObj<TextoEditavel[]>> => {
  const res = await axios.get<ResponseObj<TextoEditavel[]>>('textos_editaveis');
  return res.data;
};

const alteraTextoEditavel = async (
  formData: TextoEditavel,
): Promise<ResponseObj<TextoEditavel>> => {
  const res = await axios.put<ResponseObj<TextoEditavel>>('textos_editaveis', formData);
  return res.data;
};

export default {
  textoEditavel,
  textosEditaveis,
  alteraTextoEditavel,
};
